import { Approver } from 'models/IApprover';
import { sponsorAxiosInstance } from './base-service';

export const GetUserDetails = (): Promise<any> => {
  return sponsorAxiosInstance.get('benefit/users/v1');
};

export const GetSponsorDetails = (sponsorId: number): Promise<any> => {
  return sponsorAxiosInstance.get(`v1/Sponsor/${sponsorId}`);
};

export const GetApproversList = async (): Promise<Approver[] | undefined> => {
  try {
    const response = await sponsorAxiosInstance.get('/v1/User/AlternateApprovers');
    return response.data as Approver[];
  } catch (error) {
    return undefined;
  }
};

export const GetManager = async (): Promise<Approver | undefined> => {
  try {
    const response = await sponsorAxiosInstance.get('/v1/User/Manager');
    return response.data as Approver;
  } catch (error) {
    return undefined;
  }
};


export const updateSponsorCulture = async (culture: string): Promise<any> => {
  try {
    const response = await sponsorAxiosInstance.put(`v1/User/Culture`, { "locale": culture });
    return response.data;
  } catch (error) {
    return undefined;
  }
}
